import React, { Component } from 'react';
import { HashRouter, Route, Switch, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';

import { AppHeader, ErrorMessage, AjaxActive } from './shared';
import { LoginPage } from './auth';
import { ContactsPage, ContactPage } from './contacts';

import './App.less';

import contactsStore from './store/contactsStore';

@observer
class App extends Component {
  componentDidMount() {
    if (contactsStore.access_token) {
      contactsStore.fetchCompanyId()
        .subscribe(() => {});
    }
  }

  render() {
    var components = [];

    if (contactsStore.access_token) {
      components.push(
        <Route key="login" path="/login" component={LoginPage} />
      );
      components.push(
        <Route key="cm1-list" path="/cm1" exact component={ContactsPage} />
      );
      components.push(
        <Route key="cm1-single" path="/cm1/:subNr" component={ContactPage} />
      );
      components.push(
        <Route
          key="root"
          path="/"
          exact
          render={() => <Redirect to="/cm1" />}
        />
      );
      components.push(
        <Route key="miss" render={() => <Redirect to="/cm1" />} />
      );
    } else {
      components.push(
        <Route key="login" path="/login" component={LoginPage} />
      );
      components.push(
        <Route key="miss" render={() => <Redirect to="/login" />} />
      );
    }

    return (
      <HashRouter>
        <div className="container">
          <AppHeader /> 
          <AjaxActive />
          <ErrorMessage errorMessage={contactsStore.errorMessage} />
          <Switch>
            {components}
          </Switch>
        </div>
      </HashRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js